// we have a clone in the https://github.com/miroapp-dev/miro-site/blob/3d208d829b58f612309b62877c49ad8f9282297e/packages/shared/custom-server/src/middlewares/localeDetectionMiddlewareFactory.ts
// update the clone if you update this
export default function buildCookieDomainAttributeValue() {
  var host = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'miro.com';
  var hostParts = host.split('.');
  var secondLevelDomain = hostParts.slice(-2).join('.');

  if (secondLevelDomain === 'testmiro.com') {
    return hostParts.slice(-3).join('.');
  }

  if (secondLevelDomain === 'miro-stg.net') {
    return secondLevelDomain;
  }

  if (secondLevelDomain !== 'miro.com') {
    // eslint-disable-next-line no-console
    console.warn("Request received from unknown domain: ".concat(host));
  }

  return 'miro.com';
}